import { BusinessSegment, BusinessSegmentResult, useRepositoryQuery } from '@mews-commander/data-access';
import { keyBy } from '@mews/fp';
import { createWeakMapSelector } from '@mews/framework';
import { useCurrentEnterpriseId } from '../session';

export const useEnterpriseBusinessSegmentsQuery = <T = BusinessSegmentResult>(
    select?: (data: BusinessSegmentResult) => T
) => {
    const enterpriseId = useCurrentEnterpriseId();
    return useRepositoryQuery(
        'businessSegments',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
        },
        { staleTime: 60 * 60 * 1000, gcTime: Infinity, select } // 1 hour stale time, no garbage collection
    );
};

const getBusinessSegmentsById = createWeakMapSelector(
    (businessSegments: BusinessSegment[]): Record<string, BusinessSegment> => keyBy('id', businessSegments)
);
export const getQueryBusinessSegmentsById = createWeakMapSelector((data: BusinessSegmentResult) =>
    getBusinessSegmentsById(data.businessSegments)
);
